function Loading() {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="spinner-border m-5" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default Loading;
